import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "@/contexts/AuthContext";
import Navbar from "@/components/site/Navbar";
import DropBanner from "@/components/site/DropBanner";
import Landing from "@/pages/Landing";
// Live Map temporarily disabled pre-launch — re-enable when road trip begins.
// import MapPage from "@/pages/MapPage";
import FeedPage from "@/pages/FeedPage";
import MeetupsPage from "@/pages/MeetupsPage";
import ShopPage from "@/pages/ShopPage";
import ChatPage from "@/pages/ChatPage";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import DashboardPage from "@/pages/DashboardPage";
import SuccessPage from "@/pages/SuccessPage";
import TourPassPage from "@/pages/TourPassPage";
import PressPage from "@/pages/PressPage";
import RsvpPage from "@/pages/RsvpPage";
import FuelPage from "@/pages/FuelPage";
import CommentPage from "@/pages/CommentPage";
import LinksPage from "@/pages/LinksPage";
import LoungePage from "@/pages/LoungePage";
import BucketListPage from "@/pages/BucketListPage";

// Hoisted so the object identity is stable across renders (breaks React memoization
// when inlined as a prop).
const TOASTER_OPTIONS = {
  style: {
    background: "#141414",
    border: "1px solid rgba(255,255,255,0.1)",
    color: "white",
    borderRadius: "0",
  },
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Navbar />
          <DropBanner />
          <Routes>
            <Route path="/" element={<Landing />} />
            {/* <Route path="/map" element={<MapPage />} /> — pre-launch: re-enable when journey begins */}
            <Route path="/feed" element={<FeedPage />} />
            <Route path="/meetups" element={<MeetupsPage />} />
            <Route path="/shop" element={<ShopPage />} />
            <Route path="/chat" element={<ChatPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/tour-pass" element={<TourPassPage />} />
            <Route path="/press" element={<PressPage />} />
            <Route path="/rsvp" element={<RsvpPage />} />
            <Route path="/fuel" element={<FuelPage />} />
            <Route path="/comment" element={<CommentPage />} />
            <Route path="/links" element={<LinksPage />} />
            <Route path="/lounge" element={<LoungePage />} />
            <Route path="/bucket-list" element={<BucketListPage />} />
            <Route path="/checkout/success" element={<SuccessPage />} />
          </Routes>
          <Toaster theme="dark" position="top-right" toastOptions={TOASTER_OPTIONS} />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
